/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {Grid, Row, Col} from 'eui-components';

import InstitutionPicker from '../InstitutionPicker';
import InstitutionHeader from '../InstitutionHeader';
import {DomainApplicationMenuContainer} from './DomainApplicationMenuContainer';
import {DomainApplicationFrameContainer} from './DomainApplicationFrameContainer';

import styles from './DomainApplicationView.css';

class DomainApplicationView extends Component {
    static propTypes = {
      /**
       * User's current context institution.
       */
      institution: PropTypes.object,

      /**
       * User's available institutions.
       */
      institutions: PropTypes.arrayOf(PropTypes.object),

      /**
       * Callback method invoked when the user changes their context institution.
       */
      onChangeContextInstitution: PropTypes.func.isRequired,

      /**
       * Requires React Router's history object to be on the props.
       */
      history: PropTypes.shape({
        push: PropTypes.func.isRequired
      }).isRequired,

      match: PropTypes.shape({
        url: PropTypes.string.isRequired
      }).isRequired
    };

    constructor (props) {
      super(props);
      this.state = {
        showInstitutionPicker: false,
        promptedForInstitution: false
      };
    }

    render () {
      // declare the picklist once, so we can choose to either display it alone or as part of the broader view.
      const instituionPickList = <InstitutionPicker show={this.state.showInstitutionPicker}
        institutions={this.props.institutions}
        onSelect={this.changeContextInstitution}
        onHide={this.cancelInstitutionPicker}/>;

      return (
        <Grid fluid={true} className={styles.container}>
          <Row>
            <Col sm={3} md={3} lg={2} className={styles.applicationMenuSection}>
              <DomainApplicationMenuContainer />
            </Col>
            <Col sm={9} md={9} lg={10} className={styles.applicationSection}>
              <InstitutionHeader institution={this.props.institution}
                onChangeInstitution={this.showInstitutionPicker}/>
              <DomainApplicationFrameContainer />
              {instituionPickList}
            </Col>
          </Row>
        </Grid>
      );
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
      if (!this.state.promptedForInstitution && (!prevProps.institution && !this.props.institution)) {
        this.showInstitutionPicker();
      } else {
        if (this.state.showInstitutionPicker && (!prevProps.institution && this.props.institution)) {
          this.cancelInstitutionPicker();
        }
      }
    }

    /**
     * Prompt the user to select a different institution.
     */
    showInstitutionPicker = () => {
      this.setState({showInstitutionPicker: true, promptedForInstitution: true});
    };

    /**
     * Cancel swtiching the user's context institution.  If the user hasn't selected an institution yet, they
     * should get a limited menu of applications.  If a previous institution was selected, their current
     * context institution remains active.
     */
    cancelInstitutionPicker = () => {
      this.setState({showInstitutionPicker: false});
    };

    /**
     * Change the user's current context institution by hiding the institution picker and notifying the parent state
     * container.
     *
     * @param institution the new context institution
     */
    changeContextInstitution = (institution) => {
      this.cancelInstitutionPicker();
      this.props.onChangeContextInstitution(institution);
      this.props.history.push(this.props.match.url);
    };
}

export default DomainApplicationView;



// WEBPACK FOOTER //
// ./src/DomainApplicationView/DomainApplicationView.js